// extracted by mini-css-extract-plugin
export default {"container":"MainNav_container__43yEa"};